import ls from '../../utils/localStorage.js';
import { getUserInfo,getUserLogout,getUserReportQuery,getUserReportShow } from '../../api/api';

// 定义默认数据
const data = {
    "id":"1",
    "name":"彪哥",
    "phone":"13800138000"
}

const state = {
    user_info: ls.getItem('user_info') ? ls.getItem('user_info') : data,
    user_report_list: '',
    user_report_detail:''
}

const mutations = {
    UPDATE_USER_INFO(state,payload) {
        state.user_info = JSON.parse(payload);
    },
    UPDATE_USER_REPORT_LIST(state,payload) {
        state.user_report_list = JSON.parse(payload);
    },
    UPDATE_USER_REPORT_DETAIL(state,payload) {
        state.user_report_detail = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 用户信息
    requestUser(store,item) {
        getUserInfo().then( data => {
            ls.setItem('user_info',data.data);
            store.commit('UPDATE_USER_INFO',JSON.stringify(data.data));
        }).catch(error => {

        })
    },

    // 退出用户
    requestLogout(store,item) {
        getUserLogout().then( () => {
            ls.removeItem('access_token');
            ls.removeItem('user_info');
            store.commit('UPDATE_USER_INFO',null);
            //return item.thit.$router.push('/home');
            return window.location.href="/home";
        }).catch(error => {

        })
    },

    // 我的报备查询
    requestUserReportQuery(store,item) {
        getUserReportQuery(item.id).then( data => {
           store.commit('UPDATE_USER_REPORT_LIST',JSON.stringify(data.data));
        }).catch(error => {

        });
    },

    // 我的报备详情
    requestUserReportDetail(store,item) {
        getUserReportShow(item.id).then( data => {
            store.commit('UPDATE_USER_REPORT_DETAIL',JSON.stringify(data.data));
        }).catch(error => {

        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}
